module.exports = __webpack_public_path__ + "img/img68.e6ba7baf.svg";